function RegisterViewModel() {
    var self = this;

    var companyCustomerTypeId = "1";
    var privateCustomerTypeId = "2";
    self.UserCustomerTypeId = ko.observable(companyCustomerTypeId);
    self.IsPrivateUserCustomerTypeDisabled = ko.observable(false);
    self.IsCompanyUserCustomerTypeDisabled = ko.observable(false);

    self.BranchId = ko.observable("-1");
    self.Company = ko.observable("").extend({
        required: {
            params: true,
            onlyIf: function() {
                return self.UserCustomerTypeId() === companyCustomerTypeId;
            }
        }
    });
    self.CompanyAddition = ko.observable("");
    self.DivisionEnabled = ko.observable(false);

    self.isDivisionRequired = function() {
        return self.DivisionEnabled() && self.UserCustomerTypeId() === companyCustomerTypeId;
    }

    self.DivisionId = ko.observable("-1").extend({
        required: {
            params: true,
            onlyIf: function () {
                return self.isDivisionRequired();
            }
        },
        min: {
            params: 0,
            onlyIf: function() {
                return self.isDivisionRequired();
            }
        }
    });
    
    self.LatestPossibleBirthday = ko.computed(function () {
        var now = new Date();
        return new Date(Date.UTC(now.getUTCFullYear() - 16, now.getUTCMonth(), now.getUTCDate()));
    });
    self.Birthday = ko.observable("").extend({
        required: true,
        beforeDate: {
            params: self.LatestPossibleBirthday(),
            onlyIf: function () {
                return self.UserCustomerTypeId() === privateCustomerTypeId;
            }
        }
    });
    self.VatId = ko.observable("");

    self.AcceptedAgbs = ko.observable(false).extend({ required: true });
    self.AcceptedDataProtectionRegulations = ko.observable(false).extend({ required: true });
    
    self.FirstName = ko.observable("").extend({ required: true });
    self.LastName = ko.observable("").extend({ required: true });
    self.SalutationId = ko.observable("-1");
    self.TitleId = ko.observable("");
    self.Street = ko.observable("").extend({ required: true });
    self.ZipCode = ko.observable("").extend({ required: true });

    self.City = ko.observable("").extend({ required: true });
    self.CountryId = ko.observable("").extend({ required: true });
    self.StateProvinceCode = ko.observable("").extend({
        required: {
            params: true,
            onlyIf: function() {
                return countryHasStateProvinceCode(self.CountryId());
            }
        }
    });
    self.Phone = ko.observable("").extend({
        required: true,
        minLength: {
            params: 10,
            message: "Minimale Länge muss 10 betragen",
            onlyIf: function() {
                return self.CountryId() === constants.countryIds.UnitedStates;
            }
        }
    });
    self.Fax = ko.observable("");
    self.Email = ko.observable("").extend({ required: true, email: true });
    self.NewEmail = ko.observable();
    self.Password = ko.observable("").extend({ required: true, minLength: 8 });
    self.ConfirmPassword = ko.observable("").extend({ required: true, equal: self.Password });
    self.Newsletter = ko.observable(false);

    self.PasswordStrength = ko.observable("short");
    
    self.PasswordRequired = ko.observable(true);
    self.AgbsAndRegulationsRequired = ko.observable(true);
    self.ShowStateProvinceCode = ko.observable(false);
    self.IsStateProvinceCodeRequired = ko.observable(false);
    self.showVat = ko.observable(false);
    self.vatValid = ko.observable(false);
    self.showValid = ko.observable(false);
    self.CheckingRegistry = ko.observable(false);
    self.IsNewsletterEmailInUse = ko.observable(false);
    self.Errors = ko.observableArray([]);

    self.throttledZip = ko.computed(self.ZipCode).extend({ throttle: 400 });

    //subData
    self.FirstNameHasError = ko.observable(false);
    self.LastNameHasError = ko.observable(false);
    self.CompanyHasError = ko.observable(false);
    self.CompanyAdditionHasError = ko.observable(false);
    self.DivisionIdHasError = ko.observable(false);
    self.PhoneHasError = ko.observable(false);
    self.FaxHasError = ko.observable(false);
    self.EmailHasError = ko.observable(false);
    self.NewEmailHasError = ko.observable(false);
    self.StreetHasError = ko.observable(false);
    self.CityHasError = ko.observable(false);
    self.ZipCodeHasError = ko.observable(false);
    self.StateProvinceCodeHasError = ko.observable(false);

    self.FirstNameProxy = ko.computed({
        read: function () {
            return self.FirstName();
        },
        write: function (newFirstName) {
            if (newFirstName.length + self.LastName().length <= 35) {
                self.FirstName(newFirstName);
                self.FirstNameHasError(false);
            } else {
                self.FirstNameHasError(true);
                self.FirstNameProxy.notifySubscribers();
            }
        },
        deferEvaluation: true,
        owner: self
    });
    self.LastNameProxy = ko.computed({
        read: function () {
            return self.LastName();
        },
        write: function (newLastName) {
            if (newLastName.length + self.FirstName().length <= 35) {
                self.LastName(newLastName);
                self.LastNameHasError(false);
            } else {
                self.LastNameHasError(true);
                self.LastNameProxy.notifySubscribers();
            }
        },
        deferEvaluation: true,
        owner: self
    });
    self.CompanyProxy = ko.computed({
        read: function () {
            return self.Company();
        },
        write: function (newCompany) {
            if (newCompany.length <= 35) {
                self.Company(newCompany);
                self.CompanyHasError(false);
            } else {
                self.CompanyHasError(true);
                self.CompanyProxy.notifySubscribers();
            }
        },
        deferEvaluation: true,
        owner: self
    });
    self.CompanyDisplayProxy = ko.computed({
        read: function () {
            if (self.Company()) {
                return self.Company().length > 35 ? self.Company().substr(0, 32) + '...' : self.Company();
            }
            return "";
        },
        write: function (newCompany) {
        },
        deferEvaluation: true,
        owner: self
    });
    self.CompanyAdditionProxy = ko.computed({
        read: function () {
            return self.CompanyAddition();
        },
        write: function (newCompanyAddition) {
            if (newCompanyAddition.length <= 50) {
                self.CompanyAddition(newCompanyAddition);
                self.CompanyAdditionHasError(false);
            } else {
                self.CompanyAdditionHasError(true);
                self.CompanyAdditionProxy.notifySubscribers();
            }
        },
        deferEvaluation: true,
        owner: self
    });
    self.DivisionIdProxy = ko.computed( {
        read: function () {
            return self.DivisionId();
        },
        write: function(newdivisonId) {
            if(newdivisonId > 0) {
                self.DivisionId(newdivisonId);
                self.DivisionIdHasError(false);
            } else {
                self.DivisionIdHasError(true);
                self.DivisionIdHasError.notifySubscribers();
            }
        },
        deferEvaluation: true,
        owner: self
    })
    self.PhoneProxy = ko.computed({
        read: function () {
            return self.Phone();
        },
        write: function (newPhone) {
            var minLength = 0;
            if(self.CountryId()=== constants.countryIds.UnitedStates){
                minLength = 10;
            }
            if (newPhone.length <= 19 && newPhone.length >= minLength) {
                self.Phone(newPhone);
                self.PhoneHasError(false);
            } else {
                self.PhoneHasError(true);
                self.PhoneProxy.notifySubscribers();
            }
        },
        deferEvaluation: true,
        owner: self
    });
    self.FaxProxy = ko.computed({
        read: function () {
            return self.Fax();
        },
        write: function (newFax) {
            if (newFax.length <= 15) {
                self.Fax(newFax);
                self.FaxHasError(false);
            } else {
                self.FaxHasError(true);
                self.FaxProxy.notifySubscribers();
            }
        },
        deferEvaluation: true,
        owner: self
    });
    self.EmailProxy = ko.computed({
        read: function () {
            return self.Email();
        },
        write: function (newEmail) {
            if (newEmail.length <= 50) {
                self.Email(newEmail);
                self.EmailHasError(false);
            } else {
                self.EmailHasError(true);
                self.EmailProxy.notifySubscribers();
            }
        },
        deferEvaluation: true,
        owner: self
    });
    
    self.NewEmailProxy = ko.computed({
        read: function () {
            return self.NewEmail();
        },
        write: function (newEmail) {
            if (newEmail.length <= 50) {
                self.NewEmail(newEmail);
                self.NewEmailHasError(false);
            } else {
                self.NewEmailHasError(true);
                self.NewEmailProxy.notifySubscribers();
            }
        },
        deferEvaluation: true,
        owner: self
    });
    
    self.StreetProxy = ko.computed({
        read: function () {
            return self.Street();
        },
        write: function (newStreet) {
            if (newStreet.length <= 35) {
                self.Street(newStreet);
                self.StreetHasError(false);
            } else {
                self.StreetHasError(true);
                self.StreetProxy.notifySubscribers();
            }
        },
        deferEvaluation: true,
        owner: self
    });
    self.CityProxy = ko.computed({
        read: function () {
            return self.City();
        },
        write: function (newCity) {
            if (newCity.length <= 30) {
                self.City(newCity);
                self.CityHasError(false);
            } else {
                self.CityHasError(true);
                self.CityProxy.notifySubscribers();
            }
        },
        deferEvaluation: true,
        owner: self
    });
    self.ZipCodeProxy = ko.computed({
        read: function () {
            return self.ZipCode();
        },
        write: function (newZipCode) {
            if (newZipCode.length <= 9) {
                self.ZipCode(newZipCode);
                self.ZipCodeHasError(false);
            } else {
                self.ZipCodeHasError(true);
                self.ZipCodeProxy.notifySubscribers();
            }
        },
        deferEvaluation: true,
        owner: self
    });

    self.StateProvinceCodeProxy = ko.computed({
        read: function () {
            return self.StateProvinceCode();
        },
        write: function (newStateProvinceCode) {
            if(newStateProvinceCode){
                if (newStateProvinceCode.length === 2) {
                    self.StateProvinceCode(newStateProvinceCode);
                    self.StateProvinceCodeHasError(false);
                } else {
                    self.StateProvinceCodeHasError(true);
                    self.StateProvinceCode.notifySubscribers();
                }
            }
        },
        deferEvaluation: true,
        owner: self
    });

    self.PopulateSettings = function (settData) {
        self.FirstName(settData.FirstName);
        self.BranchId(settData.BranchId);
        self.Company(settData.Company);
        self.CompanyAddition(settData.CompanyAddition);
        self.DivisionId(settData.DivisionId);
        self.Birthday(settData.Birthday);
        self.LastName(settData.LastName);
        self.SalutationId(settData.SalutationId);
        self.TitleId(settData.TitleId);
        self.Street(settData.Street);
        self.ZipCode(settData.ZipCode);
        self.City(settData.City);
        self.VatId(settData.VatId + "");
        self.CountryId(settData.CountryId);
        self.Phone(settData.Phone);
        self.Fax(settData.Fax);
        self.Email(settData.Email);
        self.NewEmail(self.NewEmail());
        self.StateProvinceCode(settData.StateProvinceCode);
        self.IsPrivateUserCustomerTypeDisabled(settData.IsPrivateUserCustomerTypeDisabled);
        self.IsCompanyUserCustomerTypeDisabled(settData.IsCompanyUserCustomerTypeDisabled);
        self.Newsletter(settData.Newsletter);
        self.UserCustomerTypeId(settData.UserCustomerTypeId.toString());
    };

    self.LoadSettingData = function () {
        $.getJSON(ajaxUrls.account.Settingsjson, function (data) {
            if (data.Success) {
                self.PopulateSettings(data.Model);
            } else {
                console.error("Exception at OverView : LoadOverViewData() -> " + data.Error);
                alerts.error();
            }
        }).fail(function () {
            alerts.error();
        });
    };

    self.VatId.subscribe(function (val) {
        if (val !== "") {
            const vat = val.replace(/\s+/g,"");
            const regexEuVatIds =
                /^(^$|(AT)U[0-9]{8}|(BE)0[0-9]{9}|(BG)[0-9]{9,10}|(CY)[0-9]{8}L|(CZ)[0-9]{8,10}|(DE)[0-9]{9}|(DK)[0-9]{8}|(EE)[0-9]{9}|(EL|GR)[0-9]{9}|(ES)[0-9A-Z][0-9]{7}[0-9A-Z]|(FI)[0-9]{8}|(FR)[0-9A-Z]{2}[0-9]{9}|(GB)([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})|(HU)[0-9]{8}|(IE)[0-9]S[0-9]{5}L|(IT)[0-9]{11}|(LT)([0-9]{9}|[0-9]{12})|(LU)[0-9]{8}|(LV)[0-9]{11}|(MT)[0-9]{8}|(NL)[0-9]{9}B[0-9]{2}|(PL)[0-9]{10}|(PT)[0-9]{9}|(RO)[0-9]{2,10}|(SE)[0-9]{12}|(SI)[0-9]{8}|(SK)[0-9]{10})$/;
            if (regexEuVatIds.test(vat)) {
                $.ajax({
                    type: "POST",
                    url: ajaxUrls.order.CheckVat,
                    data: { vat: vat }
                }).success(function (erg) {
                    self.vatValid(erg.valid);
                }).fail(function () {
                    alerts.error();
                });
            } else {
                self.vatValid(false);
            }
            self.showValid(true);           
        } else {
            self.showValid(false);
        }
    }, this);

    self.CountryId.subscribe(function (val) {
        if (countryHasStateProvinceCode(val)) {
            self.IsStateProvinceCodeRequired(true);
        } else {
            self.IsStateProvinceCodeRequired(false);
        }

        $.ajax({
            type: "GET",
            url: ajaxUrls.area.ajax.country.IsEuCountry,
            data: { id: val }
        }).done(function (isEu) {
            self.showVat(isEu);
        }).fail(function () {
            alerts.error();
        });
    }, this);

    self.Password.subscribe(function (val) {
        // Force ConfirmPassword to validate
        self.ConfirmPassword.valueHasMutated();
    }, this);

    self.Email.subscribe(function (val) {
        $.ajax({
            type: "POST",
            url: ajaxUrls.newsletter.IsEmailInUse,
            data: { email: val }
        }).done(function (data) {
            if (data && data.Success) {
                self.IsNewsletterEmailInUse(data.EmailInUse);
            } else {
                self.IsNewsletterEmailInUse(false);
            }
        }).fail(function () {
            alerts.error();
        });
    }, this);
}

function checkStrength(password) {
    var strength = 0;
    if (password.length < 6) {
        $('.passwordStrengthResult').removeClass('short').removeClass('weak').removeClass('good').removeClass('strong');
        $('.passwordStrengthResult').addClass('short');
        return '';
    }
    if (password.length > 7) strength += 1;
    if (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) strength += 1;
    if (password.match(/([a-zA-Z])/) && password.match(/([0-9])/)) strength += 1;
    if (password.match(/([!,%,&,@,#,$,^,*,?,_,~])/)) strength += 1;
    //if it has two special characters, increase strength value
    if (password.match(/(.*[!,%,&,@,#,$,^,*,?,_,~].*[!,",%,&,@,#,$,^,*,?,_,~])/)) strength += 1;
    //now we have calculated strength value, we can return messages
    //if value is less than 2
    if (strength < 2) {
        $('.passwordStrengthResult').removeClass('short').removeClass('weak').removeClass('good').removeClass('strong');
        $('.passwordStrengthResult').addClass('weak');
        return '';
    } else if (strength == 2) {
        $('.passwordStrengthResult').removeClass('short').removeClass('weak').removeClass('good').removeClass('strong');
        $('.passwordStrengthResult').addClass('good');
        return '';
    } else {
        $('.passwordStrengthResult').removeClass('short').removeClass('weak').removeClass('good').removeClass('strong');
        $('.passwordStrengthResult').addClass('strong');
        return '';
    }
}

function setDatePicker(panel) {
    panel.find(".editor-item .dateSelect, .Forms .dateSelect").kendoDatePicker({
        animation: {
            close: {
                effects: "fadeOut",
                duration: 300,
                show: false
            }
        },
        start: "decade"
    });
}

function setDropDownLists(panel) {
    panel.find(".editor-item select").kendoDropDownList();
    panel.find(".Forms select").kendoDropDownList();

    panel.find("select.Country").each(function () {
        var ddlCountry = $(this).data("kendoDropDownList");
    });
}

function setZipCodeCompletion(panel) {
}

function validateRegisterModel(model) {
    var valid = true;
    var models = [
        model.FirstName,
        model.LastName,
        model.Street,
        model.ZipCode,
        model.City,
        model.Phone,
        model.Email,
        model.StateProvinceCode
    ];

    if (registerViewModel.UserCustomerTypeId() == companyCustomerTypeId){
        models.push(model.Company)
    }

    else if (registerViewModel.UserCustomerTypeId() == privateCustomerTypeId){
        models.push(model.Birthday)
    }
    
    if (registerViewModel.PasswordRequired()) {
        models.push(model.Password);
        models.push(model.ConfirmPassword);
    }

    if (registerViewModel.AgbsAndRegulationsRequired()) {
        models.push(model.AcceptedAgbs);
        models.push(model.AcceptedDataProtectionRegulations);
    }
    
    if(registerViewModel.isDivisionRequired()) {
        models.push(model.DivisionId);
    }

    for (var i = 0; i < models.length; i++) {
        models[i].validate(models[i]());
        if (models[i].hasError()){
            valid = false;
        }
    }
    return valid;
}

$(document).ready(function () {
    var errorDialog;
    var hintDialog;
    
    $(".passwordStrengthChecked").on("keyup", function () {
        var value = $(this).val();
        registerViewModel.PasswordStrength(checkStrength(value));
    });

    $("#regTabstrip").kendoTabStrip({
        animation: {
            open: {
                effects: "fadeIn"
            }
        }
    });

    setDatePicker($(document));

    $("#btnSubmitRegistration").on("click", function () {
        if (validateRegisterModel(registerViewModel)) {
            const companyCustomerTypeId = "1";
            if (!registerViewModel.showVat() || registerViewModel.UserCustomerTypeId() !== companyCustomerTypeId || registerViewModel.vatValid()) {
                SubmitRegister();
            }
        }
        return false;
    });

    function SubmitRegister() {
        registerViewModel.CheckingRegistry(true);
        $.ajax({
            url: ajaxUrls.account.Register,
            type: 'POST',
            data: ko.toJSON(registerViewModel),
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
        }).done(function (response) {
            if (response.Success == true) {
                window.location.href = response.RedirectTo;
            } else {
                var id = "#RegisterErrorMessages";
                
                if (!errorDialog) {
                    var Modal = shop.ts.modal.GetModal();
                    errorDialog = new Modal(id, {
                        title: "Hinweis!",
                        width: "500px"
                    });
                }

                errorDialog.open();
                registerViewModel.Errors.removeAll();
                $.each(response.Errors, function (index, item) {
                    registerViewModel.Errors.push(item);
                });
            }
        }).fail(function () {
            alerts.error();
        }).always(function() {
            registerViewModel.CheckingRegistry(false);
        });
    }

    $(".UstIdCancel").on("click", function () {
        var win = $("#hint").data("kendoWindow");
        if (win) {
            win.close();
            $("#tbxUstid").focus();
            return false;
        }
    });
    $(".UstIdSubmit").on("click", function () {
        var win = $("#hint").data("kendoWindow");
        if (win) {
            win.close();
            SubmitRegister();
        }
    });

    $("#btnChangeEditVatId").on("click", function () {        
        if (hintDialog) {
            hintDialog.close();
            $("#tbxUstid").focus();
            return false;
        }
    });

    $("#btnSubmitRegistrationInHint").on("click", function () {
        if (hintDialog) {
            hintDialog.close();
            SubmitRegister();
        }
    });

    setZipCodeCompletion($(document));
});

function validateVat(val) {
    if (val !== "") {
        const vat = val.replace(/\s+/g,"");
        let isValid = false;
        const regexEuVatIds =
            /^(^$|(AT)U[0-9]{8}|(BE)0[0-9]{9}|(BG)[0-9]{9,10}|(CY)[0-9]{8}L|(CZ)[0-9]{8,10}|(DE)[0-9]{9}|(DK)[0-9]{8}|(EE)[0-9]{9}|(EL|GR)[0-9]{9}|(ES)[0-9A-Z][0-9]{7}[0-9A-Z]|(FI)[0-9]{8}|(FR)[0-9A-Z]{2}[0-9]{9}|(GB)([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})|(HU)[0-9]{8}|(IE)[0-9]S[0-9]{5}L|(IT)[0-9]{11}|(LT)([0-9]{9}|[0-9]{12})|(LU)[0-9]{8}|(LV)[0-9]{11}|(MT)[0-9]{8}|(NL)[0-9]{9}B[0-9]{2}|(PL)[0-9]{10}|(PT)[0-9]{9}|(RO)[0-9]{2,10}|(SE)[0-9]{12}|(SI)[0-9]{8}|(SK)[0-9]{10})$/;
        if (regexEuVatIds.test(vat)) {
            $.ajax({
                type: "POST",
                url: ajaxUrls.order.CheckVat,
                data: { vat: vat }
            }).success(function (erg) {
                isValid = erg.valid;
            }).fail(function () {
                alerts.error();
            });
        } else {
            isValid = false;
        }
        console.log(isValid);
        return isValid
    } else {
        return false;
    }
}
